import { tsInitVue } from './js-utils'
import ActivityDigestGrid from '../js/vue-components/activity-digest-grid.vue'
import EventReportManager from '../js/vue-components/event-report-manager.vue'

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('body.activity-digest-reports')) {
    const digestGridEl = document.querySelector('div[data-is="ActivityDigestGrid"]')
    if (digestGridEl instanceof HTMLElement) {
      const digestGridProps = {
        listUrl: digestGridEl.dataset.listUrl,
        initialFilters: digestGridEl.dataset.initialFilters,
        viewInvitationUrl: digestGridEl.dataset.viewInvitationUrl,
      }
      window.activityDigestGrid = tsInitVue(ActivityDigestGrid, digestGridEl, digestGridProps)
    }
  }
  if (document.querySelector('body.event-reports')) {
    const eventReportEl = document.querySelector('div[data-is="EventReportManager"]')
    if (eventReportEl instanceof HTMLElement) {
      const eventReportProps = {
        listUrl: eventReportEl.dataset.listUrl || '',
        reportUrl: eventReportEl.dataset.reportUrl || ''
      }
      window.eventReportsManager = tsInitVue(EventReportManager, eventReportEl, eventReportProps)
    }
  }
})
